import axios from "axios";
import {
  SETTINGS_DOCUMENT_TYPE_ERROR,
  SETTINGS_DOCUMENT_TYPE_CLEAR_SNACKBAR,
  SETTINGS_DELETE_DOCUMENT_TYPE_SUCCESS,
  SETTINGS_GET_DOCUMENT_TYPE_LOADING,
  SETTINGS_ADD_DOCUMENT_TYPE_ERROR,
  SETTINGS_ADD_DOCUMENT_TYPE_SUCCESS,
  SETTINGS_ADD_DOCUMENT_TYPE,
  SETTINGS_GET_DOCUMENT_TYPE,
  SETTINGS_COMPANY_TYPE_CLEAR_SNACKBAR,
  SETTINGS_COMPANY_TYPE_ERROR,
  SETTINGS_DELETE_COMPANY_TYPE_SUCCESS,
  SETTINGS_GET_COMPANY_TYPE_LOADING,
  SETTINGS_ADD_COMPANY_TYPE_ERROR,
  SETTINGS_ADD_COMPANY_TYPE_SUCCESS,
  SETTINGS_ADD_COMPANY_TYPE,
  SETTINGS_GET_COMPANY_TYPE,
  SETTINGS_MARKET_SECTOR_CLEAR_SNACKBAR,
  SETTINGS_MARKET_SECTOR_ERROR,
  SETTINGS_DELETE_MARKET_SECTOR_SUCCESS,
  SETTINGS_GET_MARKET_SECTOR_LOADING,
  SETTINGS_ADD_MARKET_SECTOR_ERROR,
  SETTINGS_ADD_MARKET_SECTOR,
  SETTINGS_GET_MARKET_SECTOR,
} from "../constants/types";
import queryString from "query-string";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchMarketSector = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_MARKET_SECTOR_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/marketSectors`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_MARKET_SECTOR,
            payload: {
              marketSector: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_MARKET_SECTOR_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all marketSectors.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdateMarketSector = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_MARKET_SECTOR,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.marketSectorId ? "PUT" : "POST",
        url: `${server_url}/marketSectors${
          formData.marketSectorId ? `/${formData.marketSectorId}` : ""
        }`,
        body: { ...data },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_COMPANY_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.marketSectorId
                ? "MarketSector updated Successfully"
                : "MarketSector Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_MARKET_SECTOR_ERROR,
            payload: {
              text: "Error occurred during creating marketSector data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const marketSectorDelete = ({
  marketSectorId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the market sectorsDelete Action", marketSectorId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_MARKET_SECTOR_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/marketSectors/${marketSectorId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchMarketSector({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_MARKET_SECTOR_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "marketSector Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_MARKET_SECTOR_ERROR,
            payload: {
              text: "Error occurred during deleting marketSector data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const marketSectorClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_MARKET_SECTOR_CLEAR_SNACKBAR,
    });
  };
};
